module.exports = __webpack_public_path__ + "img/Postmodernisme_Tor-Obrestad.79389508.jpg";